export default __webpack_public_path__ + "static/harriet-5af245cef3c5bdb0af41e25d6023ce4f.jpg";